// WordPress dependencies
import { __ } from "@wordpress/i18n";

// Internal dependencies
import MediaUploader from "../elements/media-uploader";
import ProFeatureControl from "../elements/pro-feature-control";
import ToggleSwitch from "../elements/ToggleSwitch";

const coreAssets = window.COCA_BAIS_ASSETS;

export default (props) => {
    const isVideo = props.attributes.slider_type === "video";
    const isTriple = props.attributes.slider_type === "triple";
    const isRetouch = props.attributes.slider_type === "retouch";

    if (isVideo || isTriple || isRetouch) {
        return null;
    }

    return (
        <ProFeatureControl {...props} value={"indicator_image"}>
            {/* <div className={"field-control field-inline"}>
                <span className="field-control__label fw-600">{__("Indicator Image", "wp-before-after-image-slider")}</span>
                <div className={"fields-wrapper inline"}>
                    <ToggleSwitch initialValue={showIndicator || false} onChange={(value) => setShowIndicator(value)} />
                    {!props.proSettings.is_pro_active && (
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            target="_blank"
                            style={{ marginTop: "6px" }}
                            title="Buy Pro"
                        >
                            <img src={coreAssets.icons.premium} alt="Premium Icon" />
                        </a>
                    )}
                </div>
            </div> */}
            <div className={"field-control field-inline"}>
                <span className="field-control__label">{__("Indicator Image", "wp-before-after-image-slider")}</span>
                <div className={"fields-wrapper inline"}>
                    <ToggleSwitch
                        initialValue={props.attributes.showIndicator || false}
                        onChange={(value) =>
                            props.updateAttributes({
                                showIndicator: value,
                            })
                        }
                    />

                    {!props.proSettings.is_pro_active && (
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            target="_blank"
                            style={{ marginTop: "6px" }}
                            title="Buy Pro"
                        >
                            <img src={coreAssets.icons.premium} alt="Premium Icon" />
                        </a>
                    )}
                </div>
            </div>
            {props.attributes.showIndicator ? (
                <div className={"field-control field-col field-control__start"}>
                    <span className="field-control__label">{__("Image", "wp-before-after-image-slider")}</span>
                    <div className={"fields-wrapper inline"}>
                        <MediaUploader
                            value={props.attributes.indicator_image}
                            onChange={(attachment) => props.updateAttributes({ indicator_image: attachment })}
                            isProFeature={true}
                            proFeatureEnabled={!!props.proFeatureEnabled}
                        />
                    </div>
                </div>
            ) : null}
        </ProFeatureControl>
    );
};
